module.exports = __webpack_public_path__ + "images/Cans-fan-01.png";